import { graphql } from "@/gql";

export const reopenIncidentMutation = graphql(`
  mutation ReopenIncident($id: ID!, $reason: String!) {
    reopenIncident(id: $id, reason: $reason) {
      id
      status
    }
  }
`);
